import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';
import {Button, Card, Form, Loader, Icon} from 'semantic-ui-react';
import moment from 'moment';
import {Actions} from '../../../../../common/actions';
import {WAREHOUSE_DENIAL_CAUSE_FORM} from '../../../../../common/forms';
import {hasAccessPermission} from '../../../../../common/permissions/validations';
import {paths} from '../../../../../common/dictionaries/urls';
import {originModificationDate} from '../../../../../common/constants/datesFormat';
import {resources, scopes} from '../../../../../common/permissions/dictionary';
import {InputField, CheckboxField} from '../../../../../common/components/form';
import {
  setErrorMessage,
  clearErrorMessage,
} from '../../../../../common/components/form/common';

class WarehouseDenialCauseForm extends Component {
  constructor(props) {
    super(props);
    this.onCancelClick = this.onCancelClick.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingWarehouseDenialCauses,
        scopes.See
      ) &&
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingWarehouseDenialCauses,
        scopes.Edit
      )
    ) {
      this.props.push(paths.AccessDenied);
    }
    const {code} = this.props;
    if (code) {
      this.props.fetchWarehouseDenialCause(code);
    }
  }

  componentDidUpdate(prevProps) {
    const {code} = this.props;
    if (prevProps.code !== code) {
      this.props.fetchWarehouseDenialCause(code);
    }
  }

  onCancelClick() {
    this.props.goBack();
  }

  renderSaveButton() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingWarehouseDenialCauses,
        scopes.Edit
      )
    ) {
      return null;
    }
    const {submitting} = this.props;
    return (
      <Button primary type='submit' disabled={submitting}>
        Guardar
      </Button>
    );
  }

  renderStatusField() {
    const {code} = this.props;

    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingWarehouseDenialCauses,
        scopes.Disabled
      )
    ) {
      return null;
    }

    return (
      <div className='page-row'>
        <div className='field-label'>
          <label>Estado</label>
        </div>
        <div className='field-component'>
          <Field
            type='toggle'
            name='status'
            component={CheckboxField}
            disabled={
              !code ||
              !hasAccessPermission(
                this.props.permissions,
                resources.PickingWarehouseDenialCauses,
                scopes.Edit
              )
            }
          />
        </div>
      </div>
    );
  }

  renderModificationDateField() {
    const {code, modificationDate} = this.props;

    if (!code) {
      return null;
    }

    return (
      <div className='page-row'>
        <div className='field-label'>
          <label>Última Modificación</label>
        </div>
        <div className='field-component'>
          <p>{moment(modificationDate).format(originModificationDate)}</p>
        </div>
      </div>
    );
  }

  renderFormFields() {
    const {loading} = this.props;

    if (loading) {
      return (
        <div>
          <Loader active inline='centered' />
        </div>
      );
    }

    return (
      <div className='page-content'>
        <div className='page-row'>
          <div className='field-label'>
            <label>Causa*</label>
          </div>
          <div className='field-component'>
            <Field
              name='name'
              component={InputField}
              type='text'
              onInvalid={(event) =>
                setErrorMessage('Por favor, llene este campo', event)
              }
              onInput={clearErrorMessage}
            />
          </div>
        </div>
        <div className='page-row'>
          <div className='field-label'>
            <label>Mover a TMP</label>
          </div>
          <div className='field-component'>
            <Field type='toggle' name='moveToTMP' component={CheckboxField} />
          </div>
        </div>
        {this.renderStatusField()}
        {this.renderModificationDateField()}
      </div>
    );
  }

  render() {
    const {handleSubmit, submitting, code} = this.props;

    return (
      <Form
        className='warehouse-denial-cause-form'
        onSubmit={handleSubmit}
        loading={submitting}
        autoComplete='off'
      >
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick} />
              <h2>{code ? 'Editar Causa' : 'Añadir Causa'}</h2>
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  onClick={this.onCancelClick}
                  disabled={submitting}
                >
                  Cancelar
                </Button>
                {this.renderSaveButton()}
              </div>
            </div>
          </div>
        </Card>

        <Card raised fluid>
          {this.renderFormFields()}
        </Card>
      </Form>
    );
  }
}

export {WarehouseDenialCauseForm};

const form = reduxForm({
  'form': WAREHOUSE_DENIAL_CAUSE_FORM.name,
})(WarehouseDenialCauseForm);

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.form.warehouseDenialCauses.loading,
    'modificationDate': state.warehouseDenialCauses.modificationDate,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'goBack': ownProps.goBack,
    'push': ownProps.push,
  };
};

const {fetchWarehouseDenialCause} = Actions;

export default connect(mapStateToProps, {
  fetchWarehouseDenialCause,
})(form);
